import React, { useEffect, useState } from "react"
import { FaArrowCircleUp } from "react-icons/fa"
import { Button } from "./style"

const ScrollButton = () => {
  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop
    if (scrolled > 60) {
      setVisible(true)
    } else if (scrolled <= 80) {
      setVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
		in place of 'smooth' */
    })
  }

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible)
    ;() => window.removeEventListener("scroll")
  }, [])

  return (
    <Button>
      <FaArrowCircleUp
        onClick={scrollToTop}
        style={{ display: visible ? "inline" : "none" }}
        className="w-10 h-10 text-[var(--custom-primary)]"
      />
    </Button>
  )
}

export default ScrollButton
